export enum ENV {
  API_URL = 'REACT_APP_API_URL',
}
